export interface PartialUpdateAction<O extends object, F extends keyof O> {
  field: F
  value: O[F]
}

export type OrdersAndItemsTab = 'byOrders' | 'byItems' | 'byInvoices'

export function isByItems(tab: OrdersAndItemsTab): boolean {
  return tab === 'byItems'
}